exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-warning-component .modal-header{padding:1rem 2rem}.modal-warning-component .modal-header .title{font-size:26px}.modal-warning-component .modal-card-body{padding-top:0}.modal-warning-component .content-btns{margin-top:1.4rem;text-align:right}", ""]);

// exports
